exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".link[data-v-4af784f4]{color:blue}.title[data-v-4af784f4]{font-size:20px;color:#253b6d;margin-bottom:2%}.info-description[data-v-4af784f4]{color:#686868;border:1px solid #d7d7d7;font-size:12px;padding:10px;margin:0 auto;text-align:justify}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4af784f4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/visa-and-vaccine/VisaAndVaccine.vue
// module id = 953
// module chunks = 0